export default class Form {
    constructor(json) {
        json = json || {};
        this.id = json.id || '';
        this.version = json.version || '';
        this.title = json.title || '';
        this.groups = json.groups || [];
        this.header_text = json.header_text || '';
        this.footer_text = json.footer_text || '';
        this.submitted_message = json.submitted_message || '';
        this.submitted_redirect_url = json.submitted_redirect_url || '';
        this.is_show_consumer_data = !!json.is_show_consumer_data;
        this.is_consumer_data_readonly = !!json.is_consumer_data_readonly;
    }
}